// File: frontend/src/pages/legal/CookiePreferencesPage.tsx

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FaCookieBite, FaCheck } from "react-icons/fa";
import { CookiePreferencePanel } from "../../components/common/CookieConsentBanner";
import { useCookieConsent, CookieConsent } from "../../context/CookieConsentContext";
import { LEGAL_ROUTES } from "../../services/legalService";
import "./LegalPage.css";

/**
 * Standalone page at /cerez-tercihleri.
 *
 * The Cookie Policy tells the reader they can change their choice "at any time"
 * from this address, so it must exist as a real, linkable route rather than only
 * as a dialog reachable from the bar.
 */
export const CookiePreferencesPage: React.FC = () => {
    const { t } = useTranslation();
    const { consent, savePreferences } = useCookieConsent();
    const [saved, setSaved] = useState(false);

    const handleSave = (next: CookieConsent) => {
        savePreferences(next);
        setSaved(true);
        // Confirmation is transient — it acknowledges the click without
        // permanently changing the page into a success screen
        setTimeout(() => setSaved(false), 2500);
    };

    return (
        <div className="legal-page">
            <div className="legal-header">
                <span className="legal-header-icon"><FaCookieBite /></span>
                <div className="legal-header-text">
                    <h1 className="legal-title">
                        {t("cookie_prefs_title", "Çerez Tercihleri")}
                    </h1>
                    <div className="legal-meta">
                        {t(
                            "cookie_prefs_subtitle",
                            "Seçiminizi istediğiniz zaman buradan değiştirebilirsiniz."
                        )}
                    </div>
                </div>
            </div>

            <CookiePreferencePanel initial={consent} onSave={handleSave} />

            {saved && (
                <div className="legal-saved-note">
                    <FaCheck /> {t("cookie_prefs_saved", "Tercihleriniz kaydedildi.")}
                </div>
            )}

            <nav className="legal-crosslinks">
                <Link to={LEGAL_ROUTES.COOKIE} className="legal-crosslink">
                    {t("legal_link_cookie", "Çerez Politikası")}
                </Link>
                <Link to={LEGAL_ROUTES.PRIVACY} className="legal-crosslink">
                    {t("legal_link_privacy", "Gizlilik Politikası")}
                </Link>
                <Link to={LEGAL_ROUTES.TERMS} className="legal-crosslink">
                    {t("legal_link_terms", "Kullanım Koşulları")}
                </Link>
            </nav>
        </div>
    );
};